import React from 'react'
import { LightBulbIcon } from '@heroicons/react/outline'
import { TrackedCTA } from '../CallToAction'

export interface CalloutProps {
    content?: string
    ctaUrl?: string
    ctaLabel?: string
    event?: string
    eventType?: string
    openQuickContact?: boolean
    isSecured?: boolean | string
    form?: any
    direction?: 'rtl' | 'ltr' | 'auto'
}

export const Callout = ({
    content,
    ctaUrl,
    ctaLabel,
    event,
    eventType,
    openQuickContact,
    isSecured,
    form,
    direction,
}: CalloutProps) => {
    return (
        <div className="mt-4 inline-block rounded-md border border-dashed border-gray-accent-light p-5">
            <div className="flex items-start space-x-2">
                <LightBulbIcon className="w-6 flex-shrink-0" />
                <div>
                    <div dangerouslySetInnerHTML={{ __html: content || '' }} />
                    <TrackedCTA
                        size="sm"
                        type="secondary"
                        to={ctaUrl}
                        event={{ name: event || `clicked ${ctaLabel}`, type: eventType }}
                        openQuickContact={openQuickContact}
                        form={form}
                        isSecured={isSecured}
                        direction={direction}
                    >
                        {ctaLabel}
                    </TrackedCTA>
                </div>
            </div>
        </div>
    )
}

export default Callout
